var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g, _path46, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBenefit = function SvgBenefit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 614 451"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M434.062 154.559c-1.642 0-3.202-.328-4.406-1.04l-99.04-57.174c-1.286-.739-1.97-1.806-1.97-2.983 0-1.368.957-2.71 2.654-3.667l97.699-56.408c2.983-1.724 7.389-1.888 9.989-.383l99.04 57.174c1.286.739 1.97 1.806 1.97 2.983 0 1.368-.958 2.71-2.655 3.667l-97.698 56.408c-1.615.958-3.64 1.423-5.583 1.423m-3.64-2.354c2.107 1.232 5.993 1.04 8.456-.383l97.699-56.407c1.177-.684 1.888-1.56 1.888-2.354s-.656-1.341-1.204-1.642l-99.039-57.174c-2.108-1.231-5.994-1.04-8.457.383l-97.699 56.408c-1.176.684-1.888 1.56-1.888 2.353s.657 1.342 1.204 1.643z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__a)",
    d: "M540 61.2v12.246L434 134.66 328 73.446V61.201z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__b)",
    d: "M540 61.2v12.246L434 134.66 328 73.446V61.201z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__c)",
    d: "M434 122.402 328 61.201 434 0l106 61.201z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M434 120.972 329.247 60.479l-1.247.722 106 61.201 106-61.2-1.247-.71z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m434.006 108.293-81.525-47.079 81.525-47.065 81.524 47.065z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__d)",
    d: "m434.003 108.293-81.524-47.079 81.524-47.065 81.524 47.065z",
    opacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__e)",
    d: "m434.003 2.27 81.524 47.08v11.864l-81.524-47.079V2.271z",
    opacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__f)",
    d: "m434.003 14.135-81.524 47.08V49.348L434.003 2.27z",
    opacity: 0.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__g)",
    d: "m434.003 96.415-81.524-47.066 81.524-47.078 81.524 47.078z",
    opacity: 0.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M434.003 68.157 401.43 49.35l32.573-18.808 32.573 18.807z",
    opacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m434.003 32.261 31.077 17.955 1.496-.867-32.573-18.807-32.573 18.807 1.496.867z",
    opacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__h)",
    d: "M434.003 96.415v11.878l81.524-47.079V49.35z",
    opacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__i)",
    d: "M352.479 49.35v11.864l81.524 47.079V96.415z",
    opacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "m434.006 95.129-80.409-46.436-1.116.656 81.525 47.066 81.524-47.066-1.115-.656z",
    opacity: 0.8
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M106.062 365.577c-1.642 0-3.202-.328-4.406-1.04l-99.04-57.174c-1.286-.739-1.97-1.806-1.97-2.983 0-1.368.957-2.709 2.654-3.667l97.7-56.408c2.983-1.724 7.389-1.888 9.989-.383l99.04 57.174c1.286.739 1.97 1.806 1.97 2.983 0 1.369-.958 2.71-2.654 3.668l-97.699 56.407c-1.615.958-3.64 1.423-5.583 1.423zm-3.64-2.354c2.107 1.232 5.993 1.04 8.456-.383l97.699-56.407c1.177-.684 1.888-1.56 1.888-2.354s-.656-1.341-1.204-1.642l-99.039-57.174c-2.108-1.231-5.994-1.04-8.457.383L4.066 302.054c-1.176.684-1.888 1.56-1.888 2.354 0 .793.657 1.341 1.204 1.642z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__j)",
    d: "M212 272.219v12.245l-106 61.214L0 284.464v-12.245z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__k)",
    d: "M212 272.219v12.245l-106 61.214L0 284.464v-12.245z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__l)",
    d: "M106 333.42 0 272.219l106-61.201 106 61.201z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M106 331.99 1.247 271.497 0 272.219l106 61.201 106-61.201-1.247-.708z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F054C",
    d: "m106.006 319.311-81.525-47.079 81.525-47.065 81.524 47.065z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__m)",
    d: "m106.003 319.311-81.525-47.079 81.525-47.065 81.524 47.065z",
    opacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__n)",
    d: "m106.003 213.289 81.524 47.078v11.865l-81.524-47.078z",
    opacity: 0.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__o)",
    d: "m106.003 225.154-81.525 47.078v-11.865l81.525-47.078z",
    opacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__p)",
    d: "m106.003 307.433-81.525-47.066 81.525-47.078 81.524 47.078z",
    opacity: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "M106.003 279.175 73.43 260.368l32.573-18.808 32.573 18.808z",
    opacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D4DD",
    d: "m106.003 243.279 31.077 17.955 1.496-.866-32.573-18.808-32.573 18.808 1.496.866z",
    opacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__q)",
    d: "M106.003 307.433v11.878l81.524-47.079v-11.865z",
    opacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__r)",
    d: "M24.479 260.368v11.864l81.524 47.079v-11.878l-81.525-47.065z",
    opacity: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#878AA3",
    d: "m106.006 306.147-80.409-46.436-1.116.656 81.525 47.066 81.524-47.066-1.115-.656z",
    opacity: 0.8
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#9EA1B6",
    d: "M464.727 188.715 435.182 13.323l2.36-1.002-3.577-2.039v.036c-.679-.465-1.681-.43-2.754.179l-236.257 136.4c-1.932 1.109-3.398 4.007-3.077 6.01l29.796 176.788c.144.93.609 1.538 1.252 1.789l3.506 2.003.608-3.255-.215.071 234.827-135.578c1.932-1.109 3.434-4.006 3.076-6.01"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ABACC0",
    d: "m196.277 151.691-3.899-1.717c-.429 1.002-.644 2.039-.501 2.933l29.796 176.788c.143.93.608 1.539 1.252 1.789l3.505 2.003.609-3.255-.215.071 11.875-6.868z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "m465.372 196.872-236.257 136.4c-1.824 1.038-3.398.43-3.72-1.431l-29.796-176.787c-.358-2.004 1.144-4.865 3.076-6.01l236.257-136.4c1.825-1.038 3.399-.43 3.721 1.43l29.795 176.788c.322 2.003-1.144 4.865-3.076 6.01"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E5891",
    d: "M431.856 23.912 204.111 155.375l28.222 166.521 227.602-131.393L431.856 23.91z",
    opacity: 0.51
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__s)",
    d: "m613.886 280.544-12.877 6.725-129.271-74.657c-2.146-1.252-5.938-1.109-8.442.357L240.309 341.715c-2.146-1.181-11.875-5.867-11.875-5.867l4.721 12.306h.036c.179.537.608 1.073 1.323 1.467l136.175 78.628c2.146 1.252 5.938 1.109 8.441-.358l228.174-131.75c1.037-.608 1.645-1.324 1.932-2.039z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__t)",
    d: "m613.886 280.544-12.877 6.725-129.271-74.657c-2.146-1.252-5.938-1.109-8.442.357L240.309 341.715c-2.146-1.181-11.875-5.867-11.875-5.867l4.721 12.306h.036c.179.537.608 1.073 1.323 1.467l136.175 78.628c2.146 1.252 5.938 1.109 8.441-.358l228.174-131.75c1.037-.608 1.645-1.324 1.932-2.039z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__u)",
    d: "M611.882 282.69 378.021 417.731c-2.576 1.467-6.439 1.646-8.656.358l-139.537-80.56c-2.218-1.287-1.932-3.505.608-5.008L464.297 197.48c2.575-1.467 6.438-1.646 8.656-.358l139.537 80.596c2.217 1.252 1.967 3.47-.608 4.972"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__v)",
    d: "M611.882 282.69 378.021 417.731c-2.576 1.467-6.439 1.646-8.656.358l-139.537-80.56c-2.218-1.287-1.932-3.505.608-5.008L464.297 197.48c2.575-1.467 6.438-1.646 8.656-.358l139.537 80.596c2.217 1.252 1.967 3.47-.608 4.972"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M611.88 281.331 378.019 416.372c-2.575 1.467-6.438 1.646-8.656.358l-139.537-80.56c-.715-.429-1.145-.93-1.359-1.502-.358 1.037.071 2.11 1.359 2.862l139.537 80.559c2.218 1.288 6.081 1.109 8.656-.357L611.88 282.69c1.717-1.001 2.397-2.325 1.967-3.47-.25.751-.894 1.503-1.967 2.111"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "M307.482 388.505v-2.575c0-.251.144-.358.322-.251l9.05 5.223c.179.107.322.393.322.643v2.576c0 .25-.143.358-.322.25l-9.05-5.222c-.178-.107-.322-.394-.322-.644m13.522 7.798v-2.575c0-.251.143-.358.322-.251l9.049 5.223c.179.107.322.393.322.644v2.575c0 .251-.143.358-.322.25l-9.049-5.222c-.179-.107-.322-.393-.322-.644"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#ADB1F2",
    d: "M266.204 329.945 460.54 217.727a4.17 4.17 0 0 1 4.185 0l69.214 40.029a1.48 1.48 0 0 1 0 2.576L339.711 372.479a4.17 4.17 0 0 1-4.185 0l-69.322-39.958a1.48 1.48 0 0 1 0-2.576"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__w)",
    d: "M266.204 329.945 460.54 217.727a4.17 4.17 0 0 1 4.185 0l69.214 40.029a1.48 1.48 0 0 1 0 2.576L339.711 372.479a4.17 4.17 0 0 1-4.185 0l-69.322-39.958a1.48 1.48 0 0 1 0-2.576"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8DA5",
    d: "m266.206 332.521.679.394L460.542 221.09a4.16 4.16 0 0 1 4.185 0l68.498 39.636.68-.394a1.48 1.48 0 0 0 0-2.576l-69.214-40.029a4.17 4.17 0 0 0-4.185 0L266.17 329.945c-.966.573-.966 2.004.036 2.576"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#192150",
    d: "m469.951 227.886-168.796 97.445-7.511-4.329 168.796-97.444zm18.419 10.625-158.352 91.398-7.511-4.328 158.351-91.399zm11.982 6.904-186.43 107.64-7.512-4.329 186.431-107.64zm11.986 6.94L325.907 359.994l-7.511-4.364 186.43-107.64zm11.981 6.904-186.43 107.639-7.512-4.328 186.431-107.64zM290.96 331.233l-7.512 4.328-7.511-4.328 7.511-4.328zm26.467 5.974-15.595 8.979-7.512-4.329 15.596-8.979z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__x)",
    d: "m468.016 357.097 52.402-30.264c2.039-1.18 2.039-3.112 0-4.292l-35.841-20.677c-2.039-1.18-5.365-1.18-7.404 0l-52.403 30.264c-2.039 1.18-2.039 3.112 0 4.293l35.841 20.676c2.039 1.181 5.366 1.181 7.405 0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__y)",
    d: "m468.016 357.097 52.402-30.264c2.039-1.18 2.039-3.112 0-4.292l-35.841-20.677c-2.039-1.18-5.365-1.18-7.404 0l-52.403 30.264c-2.039 1.18-2.039 3.112 0 4.293l35.841 20.676c2.039 1.181 5.366 1.181 7.405 0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#8A8DA5",
    d: "m424.772 333.881 52.403-30.264c2.038-1.18 5.365-1.18 7.404 0l35.841 20.677c.644.357 1.037.787 1.288 1.252.536-1.038.143-2.182-1.288-3.005l-35.841-20.677c-2.039-1.18-5.366-1.18-7.404 0l-52.403 30.264c-1.431.823-1.824 1.967-1.287 3.005.25-.465.679-.895 1.287-1.252"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__z)",
    d: "M464.55 197.194 230.689 332.199c-2.576 1.467-6.439 1.646-8.657.358l-139.536-80.56c-2.218-1.288-1.932-3.506.608-5.008l233.861-135.041c2.575-1.467 6.438-1.646 8.656-.358l139.537 80.595c2.217 1.288 1.931 3.506-.608 5.009",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#benefit_svg__A)",
    d: "m229.974 221.412 52.402-30.264c2.039-1.18 2.039-3.112 0-4.293l-35.841-20.676c-2.039-1.181-5.365-1.181-7.404 0l-52.403 30.263c-2.038 1.181-2.038 3.113 0 4.293l35.841 20.677c2.039 1.18 5.366 1.18 7.405 0",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9198DB",
    d: "m186.727 198.16 52.403-30.264c2.038-1.181 5.365-1.181 7.404 0l35.841 20.676c.644.358 1.037.787 1.288 1.253.536-1.038.143-2.183-1.288-3.005l-35.841-20.677c-2.039-1.18-5.366-1.18-7.404 0l-52.403 30.264c-1.43.822-1.824 1.967-1.287 3.005.25-.43.679-.859 1.287-1.252",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.11
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ADB1F2",
    d: "m163.694 268.667 194.335-112.218a4.16 4.16 0 0 1 4.185 0l69.214 40.029a1.48 1.48 0 0 1 0 2.576L237.164 311.201a4.17 4.17 0 0 1-4.185 0l-69.285-39.994c-1.002-.501-1.002-1.967 0-2.54",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9198DB",
    d: "m163.694 271.279.68.393L358.03 159.847a4.17 4.17 0 0 1 4.185 0l68.498 39.636.68-.393a1.48 1.48 0 0 0 0-2.576l-69.214-40.03a4.17 4.17 0 0 0-4.185 0L163.658 268.703c-.965.536-.965 2.003.036 2.576",
    opacity: 0.11
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24126A",
    d: "m413.328 193.795-169.297 97.731 6.689 3.899 169.297-97.766zm-17.85-10.302-160.927 92.901 6.724 3.863 160.892-92.901zm-172.944 99.841-15.023 8.692 6.724 3.864 15.024-8.693zm13.271 12.949-10.445 6.045 6.689 3.863 10.481-6.045zm148.513-119.265L196.35 285.552l6.689 3.863 187.968-108.498zm-11.195-6.439L185.154 279.113l6.725 3.863 187.969-108.534zm-11.16-6.475L173.994 272.638l6.689 3.899 187.969-108.534z",
    opacity: 0.11
  })))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M290.028 259.445a1.53 1.53 0 0 1 .743-1.574l15.617-9.007a1.514 1.514 0 0 1 1.514 2.622l-15.603 9.03a1.527 1.527 0 0 1-2.271-1.071m21.388-12.343a1.53 1.53 0 0 1 .743-1.572l7.247-4.178a1.515 1.515 0 0 1 1.516 2.622l-7.236 4.197a1.525 1.525 0 0 1-2.27-1.069m25.686-14.816a1.51 1.51 0 0 1 .736-1.563l4.464-2.573a1.514 1.514 0 0 1 1.511 2.622l-4.464 2.573a1.512 1.512 0 0 1-2.247-1.059m-5.34 2.966a1.35 1.35 0 1 1 2.66-.46l.061.367a1.347 1.347 0 0 1-2.655.459zm-7.289 4.328a1.51 1.51 0 0 1 .733-1.559l1.713-.993a1.512 1.512 0 1 1 1.516 2.616l-1.713.993a1.512 1.512 0 0 1-2.249-1.057m-19.852-4.605a1.53 1.53 0 0 1 .743-1.572l4.456-2.568a1.515 1.515 0 0 1 1.518 2.622l-4.447 2.585a1.524 1.524 0 0 1-2.27-1.067m-17.063 9.865a1.51 1.51 0 0 1 .735-1.561l11.441-6.612a1.513 1.513 0 0 1 1.513 2.619l-11.441 6.612a1.512 1.512 0 0 1-2.248-1.058m20.425-51.861a1.53 1.53 0 0 1 .742-1.574l11.411-6.594a1.527 1.527 0 1 1 1.529 2.645l-11.411 6.594a1.527 1.527 0 0 1-2.271-1.071m-7.332 4.224a1.52 1.52 0 0 1 .747-1.574l1.697-.969a1.518 1.518 0 0 1 1.514 2.632l-1.69.979a1.524 1.524 0 0 1-2.268-1.068m9.692 10.406a1.53 1.53 0 0 1 .743-1.574l11.41-6.594a1.529 1.529 0 0 1 1.529 2.646l-11.41 6.594a1.528 1.528 0 0 1-2.272-1.072m-7.332 4.247a1.51 1.51 0 0 1 .733-1.559l1.714-.993a1.511 1.511 0 1 1 1.515 2.616l-1.713.993a1.512 1.512 0 0 1-2.249-1.057m-5.893-84.131a1.51 1.51 0 0 1-.736 1.561l-24.031 13.875a1.512 1.512 0 1 1-1.512-2.62l24.031-13.875a1.512 1.512 0 0 1 2.248 1.059m9.444-5.446a1.53 1.53 0 0 1-.742 1.574l-3.792 2.193a1.528 1.528 0 0 1-1.53-2.645l3.792-2.193a1.528 1.528 0 0 1 2.272 1.071m47.109-3.112a1.53 1.53 0 0 1-.742 1.574l-23.966 13.856a1.527 1.527 0 1 1-1.529-2.646l23.966-13.856a1.527 1.527 0 0 1 2.271 1.072m9.44-5.464a1.51 1.51 0 0 1-.734 1.56l-3.822 2.211a1.513 1.513 0 0 1-1.515-2.618l3.823-2.211a1.512 1.512 0 0 1 2.248 1.058m-84.308 32.625a1.515 1.515 0 0 1-.732 1.561l-4.448 2.585a1.524 1.524 0 1 1-1.527-2.639l4.457-2.568a1.514 1.514 0 0 1 2.25 1.061m44.198-9.498a1.52 1.52 0 0 1-.737 1.588L317.801 141a1.526 1.526 0 1 1-1.527-2.645l4.468-2.575a1.523 1.523 0 0 1 2.259 1.05m-27.149-.365a1.535 1.535 0 0 1-.744 1.598l-11.394 6.585a1.53 1.53 0 0 1-1.531-2.646l11.387-6.597a1.535 1.535 0 0 1 2.282 1.06m7.31-4.209a1.52 1.52 0 0 1-.747 1.574l-1.697.97a1.518 1.518 0 0 1-1.514-2.632l1.691-.98a1.524 1.524 0 0 1 2.267 1.068m17.19-9.923a1.535 1.535 0 0 1-.746 1.599l-11.414 6.568a1.516 1.516 0 0 1-1.515-2.625l11.395-6.601a1.534 1.534 0 0 1 2.28 1.059m7.314-4.229a1.51 1.51 0 0 1-.733 1.559l-1.713.993a1.512 1.512 0 1 1-1.516-2.616l1.714-.993a1.51 1.51 0 0 1 2.248 1.057m-5.901 11.437a1.53 1.53 0 0 1-.743 1.572l-4.457 2.569a1.515 1.515 0 0 1-1.517-2.623l4.447-2.585a1.525 1.525 0 0 1 2.27 1.067m17.044-9.88c.114.63-.18 1.264-.735 1.585l-11.425 6.602a1.513 1.513 0 0 1-1.516-2.619l11.418-6.615a1.52 1.52 0 0 1 2.258 1.047m7.315-4.204a1.51 1.51 0 0 1-.733 1.559l-1.713.993a1.512 1.512 0 1 1-1.516-2.616l1.714-.993a1.51 1.51 0 0 1 2.248 1.057m-58.483 33.795a1.525 1.525 0 0 1-.743 1.573l-12.076 6.967a1.513 1.513 0 0 1-1.515-2.621l12.063-6.989a1.526 1.526 0 0 1 2.271 1.07m13.554-7.834a1.52 1.52 0 0 1-.743 1.572l-7.926 4.571a1.514 1.514 0 0 1-1.517-2.622l7.916-4.59a1.525 1.525 0 0 1 2.27 1.069m10.087-5.831a1.52 1.52 0 0 1-.742 1.571l-4.457 2.569a1.515 1.515 0 0 1-1.518-2.622l4.447-2.585a1.524 1.524 0 0 1 2.27 1.067m70.43-32.616a1.51 1.51 0 0 1-.734 1.56l-12.049 6.969a1.513 1.513 0 0 1-1.515-2.619l12.05-6.968a1.512 1.512 0 0 1 2.248 1.058m13.58-7.851a1.52 1.52 0 0 1-.737 1.587l-7.932 4.585a1.527 1.527 0 1 1-1.528-2.645l7.938-4.577a1.523 1.523 0 0 1 2.259 1.05m10.066-5.814a1.515 1.515 0 0 1-.733 1.562l-4.447 2.585a1.525 1.525 0 1 1-1.527-2.639l4.456-2.568a1.516 1.516 0 0 1 2.251 1.06m-29.092 112.33a1.525 1.525 0 0 1 .743-1.573l12.076-6.967a1.513 1.513 0 0 1 1.515 2.621l-12.063 6.989a1.526 1.526 0 0 1-2.271-1.07m-13.557 7.834a1.53 1.53 0 0 1 .743-1.573l7.927-4.571a1.514 1.514 0 0 1 1.516 2.622l-7.916 4.591a1.526 1.526 0 0 1-2.27-1.069m-10.085 5.83a1.52 1.52 0 0 1 .743-1.571l4.456-2.569a1.516 1.516 0 0 1 1.518 2.622l-4.447 2.585a1.524 1.524 0 0 1-2.27-1.067m18.706-2.761a1.51 1.51 0 0 1 .736-1.562l12.083-6.972a1.513 1.513 0 1 1 1.512 2.621l-12.083 6.972a1.513 1.513 0 0 1-2.248-1.059m-13.558 7.84a1.53 1.53 0 0 1 .741-1.573l7.919-4.593a1.534 1.534 0 1 1 1.538 2.657l-7.925 4.581a1.53 1.53 0 0 1-2.273-1.072m-10.083 5.826a1.51 1.51 0 0 1 .737-1.563l4.464-2.573a1.514 1.514 0 0 1 1.511 2.622l-4.464 2.573a1.513 1.513 0 0 1-2.248-1.059m-36.367-27.166a1.53 1.53 0 0 1 .744-1.594l2.22-1.275a1.518 1.518 0 0 1 1.524 2.626l-2.21 1.294a1.53 1.53 0 0 1-2.278-1.051m-9.456 5.453a1.52 1.52 0 0 1 .738-1.564l3.855-2.217a1.513 1.513 0 1 1 1.509 2.624l-3.854 2.217a1.514 1.514 0 0 1-2.248-1.06m-12.903-47.969a1.51 1.51 0 0 1-.734 1.56l-12.049 6.969a1.513 1.513 0 0 1-1.515-2.618l12.05-6.969a1.512 1.512 0 0 1 2.248 1.058m13.557-7.842a1.53 1.53 0 0 1-.741 1.572l-7.907 4.586a1.527 1.527 0 1 1-1.532-2.641l7.907-4.587a1.528 1.528 0 0 1 2.273 1.07m10.085-5.826a1.51 1.51 0 0 1-.736 1.562l-4.464 2.573a1.513 1.513 0 1 1-1.511-2.622l4.464-2.572a1.512 1.512 0 0 1 2.247 1.059m-32.262 26.653a1.51 1.51 0 0 1-.734 1.56l-2.214 1.281a1.512 1.512 0 1 1-1.514-2.618l2.213-1.28a1.512 1.512 0 0 1 2.249 1.057m9.477-5.45a1.53 1.53 0 0 1-.746 1.577l-3.824 2.2a1.53 1.53 0 0 1-1.525-2.651l3.824-2.2a1.53 1.53 0 0 1 2.271 1.074m13.487-7.797a1.525 1.525 0 0 1-.744 1.574l-7.889 4.538a1.514 1.514 0 0 1-1.514-2.624l7.878-4.558a1.526 1.526 0 0 1 2.269 1.07m14.834 62.908c-.106-.63.192-1.26.746-1.578l2.214-1.271a1.529 1.529 0 1 1 1.523 2.652l-2.213 1.271a1.53 1.53 0 0 1-2.27-1.074m-9.443 5.468a1.53 1.53 0 0 1 .744-1.572l3.847-2.213a1.517 1.517 0 0 1 1.517 2.625l-3.838 2.228a1.525 1.525 0 0 1-2.27-1.068m-13.487 7.8a1.53 1.53 0 0 1 .745-1.574l7.889-4.538a1.515 1.515 0 0 1 1.514 2.624l-7.878 4.558a1.526 1.526 0 0 1-2.27-1.07m30.586-25.123a1.51 1.51 0 0 1 .734-1.56l7.901-4.572a1.512 1.512 0 0 1 1.515 2.618l-7.901 4.571a1.512 1.512 0 0 1-2.249-1.057m-17.479 9.54a1.535 1.535 0 0 1 .744-1.598l11.573-6.691a1.528 1.528 0 0 1 1.532 2.645l-11.567 6.704a1.536 1.536 0 0 1-2.282-1.06m-7.311 4.209a1.52 1.52 0 0 1 .747-1.573l1.696-.97a1.519 1.519 0 0 1 1.514 2.632l-1.69.98a1.524 1.524 0 0 1-2.267-1.069m-7.045 4.07a1.52 1.52 0 0 1 .736-1.566l1.691-.98a1.524 1.524 0 1 1 1.52 2.642l-1.696.97a1.52 1.52 0 0 1-2.251-1.066m.963-41.311a1.525 1.525 0 0 1 .745-1.574l11.43-6.577a1.514 1.514 0 0 1 1.513 2.624l-11.418 6.598a1.527 1.527 0 0 1-2.27-1.071m-7.317 4.262a1.52 1.52 0 0 1 .734-1.585l1.708-.99a1.52 1.52 0 1 1 1.525 2.632l-1.708.99a1.52 1.52 0 0 1-2.259-1.047m8.319-12.849a1.53 1.53 0 0 1 .742-1.573l2.182-1.263a1.528 1.528 0 0 1 1.53 2.644l-2.182 1.263a1.527 1.527 0 0 1-2.272-1.071m17.707 5.858a1.51 1.51 0 0 1 .734-1.56l2.213-1.281a1.513 1.513 0 0 1 1.515 2.618l-2.213 1.281a1.513 1.513 0 0 1-2.249-1.058m7.153-4.139a1.53 1.53 0 0 1 .745-1.574l9.248-5.325a1.515 1.515 0 0 1 1.515 2.624l-9.237 5.345a1.527 1.527 0 0 1-2.271-1.07m14.201-8.169a1.51 1.51 0 0 1 .732-1.558l4.361-2.53a1.512 1.512 0 0 1 1.517 2.615l-4.362 2.53a1.51 1.51 0 0 1-2.248-1.057m-48.526 11.933a1.52 1.52 0 0 1 .738-1.587l3.838-2.208a1.515 1.515 0 0 1 1.514 2.624l-3.833 2.217a1.52 1.52 0 0 1-2.257-1.046m-.624-7.531a1.51 1.51 0 0 1 .734-1.56l2.214-1.281a1.512 1.512 0 0 1 1.514 2.618l-2.213 1.281a1.513 1.513 0 0 1-2.249-1.058m-9.441 5.47a1.51 1.51 0 0 1 .729-1.559l3.807-2.222a1.523 1.523 0 1 1 1.53 2.634l-3.815 2.207a1.514 1.514 0 0 1-2.251-1.06m29.955 6.65a1.53 1.53 0 0 1 .749-1.599l1.691-.966a1.527 1.527 0 0 1 1.523 2.647l-1.685.976a1.533 1.533 0 0 1-2.278-1.058m-7.025 4.053a1.52 1.52 0 0 1 .736-1.566l1.691-.979a1.523 1.523 0 1 1 1.52 2.642l-1.696.969a1.52 1.52 0 0 1-2.251-1.066m34.623 36.736a1.515 1.515 0 0 1 .734-1.562l12.564-7.276a1.527 1.527 0 1 1 1.528 2.644l-12.577 7.254a1.514 1.514 0 0 1-2.249-1.06m-17.225 9.968a1.535 1.535 0 0 1 .744-1.598l11.573-6.692a1.529 1.529 0 0 1 1.532 2.646l-11.567 6.704a1.536 1.536 0 0 1-2.282-1.06m-7.311 4.232a1.515 1.515 0 0 1 .733-1.56l1.714-.992a1.511 1.511 0 1 1 1.516 2.616l-1.714.993a1.512 1.512 0 0 1-2.249-1.057m-7.049 4.051a1.53 1.53 0 0 1 .741-1.573l1.683-.975a1.527 1.527 0 1 1 1.531 2.643l-1.683.975a1.527 1.527 0 0 1-2.272-1.07m-3.636 3.35a1.528 1.528 0 0 0-2.271-1.073l-6.903 3.985a1.528 1.528 0 0 0 1.528 2.647l6.903-3.985c.552-.318.848-.946.743-1.574",
    opacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__a",
    x1: 275.594,
    x2: 547.25,
    y1: 97.927,
    y2: 97.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__b",
    x1: 330.213,
    x2: 349.574,
    y1: 115.491,
    y2: 34.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__c",
    x1: 434,
    x2: 434,
    y2: 122.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__d",
    x1: 352.474,
    x2: 515.531,
    y1: 61.214,
    y2: 61.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__e",
    x1: 434.001,
    x2: 515.529,
    y1: 31.738,
    y2: 31.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__f",
    x1: 352.476,
    x2: 434.005,
    y1: 31.738,
    y2: 31.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__g",
    x1: 352.474,
    x2: 515.531,
    y1: 49.336,
    y2: 49.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__h",
    x1: 434.001,
    x2: 515.529,
    y1: 78.817,
    y2: 78.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__i",
    x1: 352.476,
    x2: 434.005,
    y1: 78.817,
    y2: 78.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__j",
    x1: -52.406,
    x2: 219.25,
    y1: 308.945,
    y2: 308.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA1BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__k",
    x1: 2.213,
    x2: 21.574,
    y1: 326.509,
    y2: 245.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__l",
    x1: 106,
    x2: 106,
    y1: 211.018,
    y2: 333.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__m",
    x1: 24.474,
    x2: 187.531,
    y1: 272.232,
    y2: 272.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__n",
    x1: 106.001,
    x2: 187.529,
    y1: 242.756,
    y2: 242.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__o",
    x1: 24.476,
    x2: 106.005,
    y1: 242.756,
    y2: 242.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__p",
    x1: 24.474,
    x2: 187.531,
    y1: 260.354,
    y2: 260.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__q",
    x1: 106.001,
    x2: 187.529,
    y1: 289.835,
    y2: 289.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__r",
    x1: 24.476,
    x2: 106.005,
    y1: 289.835,
    y2: 289.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#757AA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060E41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__s",
    x1: 228.412,
    x2: 613.881,
    y1: 320.441,
    y2: 320.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5761D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.178,
    stopColor: "#5C66D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#6A73DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#8289E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#A3A7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__t",
    x1: 232.457,
    x2: 318.052,
    y1: 372.385,
    y2: 152.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E819C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969AAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__u",
    x1: 357.93,
    x2: 743.604,
    y1: 307.586,
    y2: 307.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__v",
    x1: 421.165,
    x2: 421.165,
    y1: 196.258,
    y2: 418.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9195AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABACD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__w",
    x1: 400.072,
    x2: 400.072,
    y1: 217.164,
    y2: 373.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__x",
    x1: 423.242,
    x2: 521.965,
    y1: 329.482,
    y2: 329.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__y",
    x1: 472.594,
    x2: 472.594,
    y1: 300.979,
    y2: 357.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC1CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__z",
    x1: 210.583,
    x2: 596.258,
    y1: 222.095,
    y2: 222.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "benefit_svg__A",
    x1: 185.2,
    x2: 283.922,
    y1: 193.782,
    y2: 193.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0BFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#C5C4F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#D3D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9FD"
  })))));
};
export default SvgBenefit;